import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { useChartDateBarContext } from 'src/Libs/chart-kit'
import { StorageAutarky } from 'src/Libs/storage/models/storage.models'
import { useTypedSelector } from 'src/State/RootReducer'
import { getStorageAutarkyValues } from '../api/storage-autarky'
import { usePortalQuery } from 'src/Libs/api'

/**
 * A hook that fetches autarky values for a specific storage unit.
 */
const useStorageAutarkyValues = (
  isEnabled = true
): {
  data: StorageAutarky | null
  isLoading: boolean
  isError: boolean
} => {
  const storageId = useTypedSelector(s => s.storage.activeStorage)
  const { from, to } = useChartDateBarContext()
  const authFetch = useAuthFetchWithResponse()

  const fromToISOString = from?.toISOString()
  const toToISOString = to?.toISOString()

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: ['storage-autarky', storageId, fromToISOString, toToISOString],
    queryFn: () => getStorageAutarkyValues(storageId, authFetch, fromToISOString, toToISOString),
    enabled: isEnabled && Boolean(storageId),
  })

  return {
    data: data ?? null,
    isLoading,
    isError,
  }
}

export default useStorageAutarkyValues
